import styled from 'styled-components';

import { Container } from 'reactstrap';

export const ContainerCss = styled(Container)`
	align-items: center;
	padding: 0 2vw 40px 2vw;
`;

export const AttentionText = styled.div`
	margin-top: 2vh;
	text-align: center;
	font-weight: 500;
	font-size: 30px;
	line-height: 100%;
	color: ${(props) => (props.aprovar ? '#00578D' : '#FF1E58')};
`;

export const Text = styled.div`
	margin-top: 2vh;
	font-weight: 300;
	font-size: 15px;
	line-height: 160%;
	color: #4a4a49;
`;

export const TextRed = styled.div`
	margin-top: 2vh;
	font-weight: 700;
	font-size: 15px;
	line-height: 160%;
	color: #ff1e58;
`;

export const DivButton = styled.div`
	margin-top: 4vh;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const ButtonCss = styled.button`
	width: 200px;
	border: 1px solid #d2d2d2;
	border-radius: 50px;
	text-transform: none;
	padding: 16px 32px;
	font-weight: 500;
	font-size: 18px;
	line-height: 100%;
	color: ${(props) => (props.aprovar ? '#4A4A49' : '#FFFFFF')};
	background-color: ${(props) => (props.aprovar ? '#FFCC00' : '#3DB338')};
`;

export const ButtonWhite = styled.button`
	width: 200px;
	border: 1px solid #929292;
	border-radius: 50px;
	padding: 16px 32px;
	font-weight: 500;
	font-size: 18px;
	line-height: 100%;
	background-color: #e5e5e5;
`;
